import { AnyAction } from "redux";
import { IShardRepositoryUpdateConfirmationData, ShardRepositoryListItem } from "../../api/entities/shard-repository";
import { IDeleteBlockedConfirmationData } from "../../components/shard-repositories/dialogs/delete-blocked-confirmation/delete-blocked-confirmation";
import { DELETE_BLOCKED_CONFIRMATION_DIALOG_NAME, DELETE_CONFIRMATION_DIALOG_NAME, getShardRepositoryEntityName, UPDATE_CONFIRMATION_DIALOG_NAME } from "../actions/shard-repository";
import { createDialogReducer, DIALOG_DEFAULT_STATE } from "./dialog";
import { IDialogState } from "./index";

export interface IShardRepositoryState {
    [DELETE_CONFIRMATION_DIALOG_NAME]: IDialogState<ShardRepositoryListItem>;
    [DELETE_BLOCKED_CONFIRMATION_DIALOG_NAME]: IDialogState<IDeleteBlockedConfirmationData>;
    [UPDATE_CONFIRMATION_DIALOG_NAME]: IDialogState<IShardRepositoryUpdateConfirmationData>;
}

function getShardRepositoryDefaultState(): IShardRepositoryState {
    return {
        [DELETE_CONFIRMATION_DIALOG_NAME]: DIALOG_DEFAULT_STATE,
        [DELETE_BLOCKED_CONFIRMATION_DIALOG_NAME]: DIALOG_DEFAULT_STATE,
        [UPDATE_CONFIRMATION_DIALOG_NAME]: DIALOG_DEFAULT_STATE,
    };
}

const getDeleteConfirmationReducer = () => createDialogReducer(getShardRepositoryEntityName(), DELETE_CONFIRMATION_DIALOG_NAME);
const getDeleteBlockedConfirmationReducer = () => createDialogReducer(getShardRepositoryEntityName(), DELETE_BLOCKED_CONFIRMATION_DIALOG_NAME);
const getUpdateConfirmationReducer = () => createDialogReducer(getShardRepositoryEntityName(), UPDATE_CONFIRMATION_DIALOG_NAME);

export function shardRepository(state: IShardRepositoryState = getShardRepositoryDefaultState(),
                                action: AnyAction): IShardRepositoryState {
    state = getDeleteConfirmationReducer()(state, action);
    state = getDeleteBlockedConfirmationReducer()(state, action);
    state = getUpdateConfirmationReducer()(state, action);
    return state;
}
